import { render, staticRenderFns } from "./FuxianPersonnelInfo.vue?vue&type=template&id=62083886&scoped=true"
import script from "./FuxianPersonnelInfo.vue?vue&type=script&lang=js"
export * from "./FuxianPersonnelInfo.vue?vue&type=script&lang=js"
import style0 from "./FuxianPersonnelInfo.vue?vue&type=style&index=0&id=62083886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62083886",
  null
  
)

export default component.exports